import { environment } from '../config/environment';

const parseJsonSafe = async (response) => {
  try {
    return await response.json();
  } catch {
    return {};
  }
};

export const validateSession = async () => {
  const validateUrl = `${environment.baseUrl}${environment.endpoints.validate}`;

  const response = await fetch(validateUrl, {
    method: 'POST',
    credentials: 'include',
  });

  const data = await parseJsonSafe(response);
  return response.ok && data?.response === true;
};

export const apiRequest = async (path, options = {}, config = {}) => {
  const { skipValidation = false } = config;

  if (!skipValidation) {
    const isValid = await validateSession();
    if (!isValid) {
      throw new Error('Unauthorized');
    }
  }

  const response = await fetch(`${environment.baseUrl}${path}`, {
    credentials: 'include',
    ...options,
  });

  const data = await parseJsonSafe(response);

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
};
